export const valueOnlyHasLetters = (value = "") => {
    const regex = /^[a-zA-Z]+$/;
    return regex.test(value);
};

export const valueOnlyHasNumbers = (value) => {
    const regex = /^\d+$/;
    return regex.test(value);
};

export const valueOnlyHasNumbersAndLetters = (value) => {
    const regex = /^[A-Za-z0-9_-]*$/;
    return regex.test(value);
};
